<ng-container>
    <app-drawing-canvas [isDrawingMode]="drawingActive" (drawn)="handleDrawn($event)" [clearCanvasAfterDrawing]="false" ></app-drawing-canvas>
</ng-container>
